import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { ADMIN_PAGES_KEYS, NS } from '../../../../../i18n/constants/keys';
import { Tabs } from '../../../../../ui';
import { ToggleInput } from '../../../../../ui/input/toggle_input/toggle_input';
import { Assessment } from '../../../../../utils/types/assessment_types';
import { useJobPostingTabs } from './Hooks/UseJobPostingTabs';
import { IJobPostingTabs } from './Interfaces/IJobPostingTabs';
import JobPostDetails from './JobPostDetails';
import { JobPostConfig } from './JobPostConfig';

export const JobPosting: React.FC<IJobPostingTabs> = ({
  jobTitleList,
  jobDescription,
  jobPostingData,
  setJobPostingData,
  jobPostExist,
  setStages,
  autoAssessment,
}) => {
  const {
    activeTab,
    setActiveTab,
    tabTitles,
    jobPostId,
    setJobPostId,
    orgPerksAndBenefits,
    orgCompanyDetails,
    handleToggle,
    hasCCALicense,
  } = useJobPostingTabs({
    jobTitleList,
    jobDescription,
    jobPostingData,
    setJobPostingData,
    jobPostExist,
    setStages,
    autoAssessment,
  });
  const { t } = useTranslation(NS.adminPages);
  const [assessmentInfo, setAssessmentInfo] = useState<Assessment | undefined>(
    autoAssessment?.assessment,
  );
  const renderTab = () => {
    if (activeTab === 'jobPostConfig') {
      return (
        <JobPostConfig
          jobTitleList={jobTitleList}
          jobDescription={jobDescription}
          jobPostingData={jobPostingData}
          setJobPostingData={setJobPostingData}
          setActiveTab={setActiveTab}
          setJobPostId={setJobPostId}
          jobPostId={jobPostId}
          orgPerksAndBenefits={orgPerksAndBenefits}
          orgCompanyDetails={orgCompanyDetails}
          hasCCALicense={hasCCALicense}
          assessmentInfo={assessmentInfo}
          setAssessmentInfo={setAssessmentInfo}
        />
      );
    } else if (activeTab === 'jobPostDetails') {
      return (
        <JobPostDetails
          setActiveTab={setActiveTab}
          jobPostingData={jobPostingData}
          setJobPostingData={setJobPostingData}
          jobDescription={jobDescription}
          orgCompanyDetails={orgCompanyDetails}
          orgPerksAndBenefits={orgPerksAndBenefits}
          jobPostId={jobPostId}
          setJobPostId={setJobPostId}
          setStages={setStages}
        />
      );
    }
  };

  return (
    <Box sx={{ minWidth: 0 }}>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          minWidth: 0,
          flexDirection: { xs: 'column', lg: 'row' },
          gap: 1.5,
          alignItems: { lg: 'center' },
          justifyContent: { lg: 'space-between' },
        }}
      >
        <Tabs
          tabs={tabTitles}
          activeTab={activeTab}
          onTabChange={(tabValue) => {
            setActiveTab(tabValue);
          }}
        />
        <Box sx={{ display: 'flex', justifyContent: { xs: 'flex-start', lg: 'flex-end' } }}>
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              gap: 1,
              borderRadius: 2,
              border: '1px solid',
              borderColor: 'divider',
              bgcolor: 'background.paper',
              px: 1.5,
              py: 1,
            }}
          >
            <Typography variant='caption' sx={{ fontWeight: 500, color: 'text.secondary' }}>
              {t(ADMIN_PAGES_KEYS.jobOpenings.jobPost.publish)}
            </Typography>
            <ToggleInput
              toggled={jobPostingData.active}
              handleToggle={handleToggle}
              name='Scatter'
              informationText={t(ADMIN_PAGES_KEYS.jobOpenings.jobPost.disableEnable)}
            />
          </Box>
        </Box>
      </Box>
      {renderTab()}
    </Box>
  );
};

export default JobPosting;
